import { ChangeDetectionStrategy, Component, Input, OnChanges, computed, inject, signal } from '@angular/core';
import { AssetColorLabel, AssetStatus, GalleryDto } from '@nusign/picflow-backend-types';
import { AssetStatusColorPipe } from '../../../gallery/pipes/asset-status-color.pipe';
import { AssetStatusIconPipe } from '../../../gallery/pipes/asset-status-icon.pipe';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { PermissionService } from '../../../services/permission.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-asset-feedback-hints',
  templateUrl: './asset-feedback-hints.component.html',
  styleUrls: ['./asset-feedback-hints.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, AssetStatusIconPipe, AssetStatusColorPipe],
})
export class AssetFeedbackHintsComponent implements OnChanges {
  private permissionService = inject(PermissionService);
  @Input({ required: true }) likes: number;
  @Input({ required: true }) is_liked: boolean;
  @Input({ required: true }) status: AssetStatus;
  @Input({ required: true }) color_label: AssetColorLabel;
  @Input({ required: true }) gallery: GalleryDto;
  @Input({ required: true }) accessLevel: GalleryAccessLevel;
  @Input({ required: true }) commentThreadCount: number;
  showSettings = signal<{ [key: string]: boolean }>({});
  showAny = computed(() => Object.values(this.showSettings() || {}).some(v => v));

  ngOnChanges() {
    const options = this.permissionService.getAllowedAndEnabledFeedbackOptions(this.gallery, this.accessLevel);
    this.showSettings.set({
      favourite: options.includes('favourite') && !!this.likes,
      status: options.includes('status') && this.status && this.status !== 'no_status',
      color_label: options.includes('color_label') && !!this.color_label,
      comment: options.includes('comment') && !!this.commentThreadCount,
    });
  }
}
